const state = {
  recentComponent: {
      name: "",
      data: {}
  }
}

const getters = {
  getRecentComponentName: state => {
    return state.recentComponent.name
  },
  getRecentComponentData: state => {
    return state.recentComponent.data
  }
}
const mutations = {
    SET_RECENT_COMPONENT: function (state, recentComponentDetails) {
      state.recentComponent = recentComponentDetails
    }
}

export default {
  getters,
  state,
  mutations
}
